// import React, { useState } from "react";


// function DeliveryDirectionResume (props) {

//     return(
//         <div className="bg-slate-50 py-5">
//             <div className="font-bold text-2xl px-4 text-gray-600 mb-3 text-center">
//                 <p>Dirección de Despacho</p>
//             </div>
//             <div className="text-center text-gray-500">
//                 <p>
//                     {props.deliveryDirection.streetName} {props.deliveryDirection.streetNumber}
//                     { (props.deliveryDirection.houseNumber.length > 0) ? ` (Casa: ${props.deliveryDirection.houseNumber}), ` : null}
//                     { (props.deliveryDirection.departmentNumber.length > 0) ? ` (Dpto: ${props.deliveryDirection.departmentNumber}), ` : null}
//                     { (!(props.deliveryDirection.departmentNumber.length > 0) && !(props.deliveryDirection.houseNumber.length > 0)) ? `, ` : null}
//                     {props.deliveryDirection.commune}
                
//                 </p>
//             </div>
//         </div>
//     )
// }

// export default DeliveryDirectionResume;

import React from "react";

function DeliveryDirectionResume(props) {
    const d = props.deliveryDirection;

    return (
        <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">

            {/* Header */}
            <div className="px-4 py-3 flex items-center gap-2 bg-[#f6f6ee] border-b border-gray-100">
                <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <p className="text-sm font-semibold text-[#1e2a1a]">Dirección de despacho</p>
            </div>

            {/* Contenido */}
            <div className="px-4 py-3 flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-[#edf4e0] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-[#4a7c2f]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
                    </svg>
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-[13px] font-semibold text-[#1e2a1a]">
                        {d.streetName} {d.streetNumber}
                        {d.houseNumber?.length > 0 && `, Casa ${d.houseNumber}`}
                        {d.departmentNumber?.length > 0 && `, Dpto ${d.departmentNumber}`}
                    </p>
                    <p className="text-[11px] text-gray-400 mt-0.5">{d.commune}, Santiago</p>
                </div>
            </div>
        </div>
    );
}

export default DeliveryDirectionResume;